import React, { useState } from 'react';
import Rating from '@mui/material/Rating';

const ChaletRatingComponent = ({ name, defaultValue, onChange }) => {
    const [value, setValue] = useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
        onChange(newValue);
    };

    React.useEffect(() => {
        setValue(defaultValue);
    }, [defaultValue]);


    return (
        <div>
            <div className="refiner-heading">{name}</div>
            <Rating
                value={value}
                onChange={handleChange}
                max={10}
            />
        </div>
    );
};


export default ChaletRatingComponent;

// Usage in parent component
// const handleScoreSelect = (score) => {
//     // Implement your filtering logic here
// };
// <ScoreFilter onScoreSelect={handleScoreSelect} />
